import React, {useEffect, useState} from 'react';
import './App.css';
import ZoGeregeldPage from './pages/zogeregeld';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {loadLocaleAsync} from './i18n/i18n-util.async';
import {navigatorDetector} from 'typesafe-i18n/detectors';
import {detectLocale} from './i18n/i18n-util';
import TypesafeI18n from './i18n/i18n-react';
import {ErrorBoundary} from 'react-error-boundary';
import ErrorPage from './pages/ErrorPage';
import HomePage from './pages/home';

declare global {
    interface Window {
        STORE_CODE: string;
        BASE_URL: string;
        VIEW_URL: string;
        feature_flag?: {[key: string]: boolean};
    }
}

function App() {
    const locale = detectLocale(navigatorDetector);
    const [localesLoaded, setLocalesLoaded] = useState(false);

    useEffect(() => {
        loadLocaleAsync(locale).then(() => {
            setLocalesLoaded(true);
        });
    }, [locale]);

    if (!localesLoaded) {
        return null;
    }

    return (
        <ErrorBoundary
            FallbackComponent={ErrorPage}
            onReset={() => {
                window.location.reload();
            }}
            onError={(error, componentStack) => {
                console.error(error, componentStack);
            }}
        >
            <div className="App">
                <TypesafeI18n locale="nl">
                    <Router>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route
                                path="/zo-geregeld/*"
                                element={<ZoGeregeldPage />}
                            />
                            <Route
                                path="/zogeregeld/*"
                                element={<ZoGeregeldPage />}
                            />
                        </Routes>
                    </Router>
                </TypesafeI18n>
            </div>
        </ErrorBoundary>
    );
}

export default App;
